var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { Avatar, Card } from '@philips-internal/oswald-ui-components/lib/components';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { SelectionType, Size } from '@philips-internal/oswald-ui-constants';
import { eventListener, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { generateUUID, isFunction } from '@philips-internal/oswald-ui-utils';
import LoginLandingPageLinkCardAPI from './login-landing-page-link-card-api';
import './login-landing-page-link-card.css';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
let LoginLandingPageLinkCard = class LoginLandingPageLinkCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { onClick } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        ...this.props
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        avatar: string,
        description: string,
        href: string,
        onClick: eventListener,
        title: string,
    }; }
    render() {
        const { avatar, description, title } = this.props;
        return (React.createElement(Card, { className: 'login-landing-page-link-card', selectionType: SelectionType.NONE, onClick: () => this.handleClick(), transparent: true, uuid: generateUUID(), width: 3 },
            React.createElement("div", { className: 'login-landing-page-link-card-container' },
                React.createElement("div", { className: 'landing-page-link-card-avatar' },
                    React.createElement(Avatar, { image: avatar, size: Size.MEDIUM })),
                React.createElement("div", { className: 'landing-page-link-card-content' },
                    React.createElement("div", { className: 'landing-page-link-card-title' }, title),
                    React.createElement("div", { className: 'landing-page-link-card-description' }, description)))));
    }
};
LoginLandingPageLinkCard = __decorate([
    AwesomeComponent({ api: LoginLandingPageLinkCardAPI, type: ComponentType.DATA_DISPLAY })
], LoginLandingPageLinkCard);
export default LoginLandingPageLinkCard;
//# sourceMappingURL=login-landing-page-link-card.js.map